import clsx from "clsx";
import React from "react";
import "./faItemTrailing.scss";

interface IFaItemTrailingProps extends React.ComponentPropsWithoutRef<"div"> { }

export function FaItemTrailing(props: IFaItemTrailingProps) {
    return <div {...props} className={clsx("fa-item-trailing", props.className)} />;
}
